module.exports = __webpack_public_path__ + "img/school.5957018c.png";